import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/tunjangankinerjaService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'

import ReactTimeAgo from 'react-time-ago'
import moment from "moment"

import IndexBloc from "../Blocs/IndexBlock"

class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();
    indexBloc = new IndexBloc();

    rupiah = (num) => {
        let res = "-";
        if (num != null && num != ''){
            res = parseFloat(num).toLocaleString('id-ID', {maximumFractionDigits:2})
        }
        return res;
    }

    source
    historyTable = 'historyRekapAbsensiPegawaiTableActive'
    defaultOrder = 'employee_full_name'
    defaultSize = 10
    defaultSort = 'asc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            syncUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            ...additionalFilter
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.syncData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    handleSync = () => {
        this.setState({
            confirm: true
        })
    }

    syncData  = async () => {
        let additionalFilter = this.props.additionalFilter;
        
        await this.indexBloc.fetchSync({ 
            uuid: this.state.syncUuid,
            ...additionalFilter
        })
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.indexBloc.syncChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        // this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
        this.dataTableBloc.inactiveChannel.unsubscribe()
    }

    columns = [
        {
            key: "presensi_summary_employee_nip",
            text: "Pegawai",
            className: "presensi_summary_employee_nip",
            sortable: true,
            width: '80',
            cell : record => {
                return (
                  <>
                    <b>{record.presensi_summary_employee_nip}</b>
                    <div>{record.employee_full_name}</div>
                  </>
                )
            }
        },
        {
            key: "presensi_summary_presentase_tunkin_tidak_masuk",
            text: "",
            className: "presensi_summary_presentase_tunkin_tidak_masuk",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Tidak Masuk <br />
                    (Tunkin)
                  </div>
                )
              },
            cell : record => {
                return record.presensi_summary_presentase_tunkin_tidak_masuk;
            }
        },
        {
            key: "presensi_summary_presentase_ptsp_tidak_masuk",
            text: "",
            className: "presensi_summary_presentase_ptsp_tidak_masuk",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Tidak Masuk <br />
                    (Honorarium)
                  </div>
                )
              },
            cell : record => {
                return record.presensi_summary_presentase_ptsp_tidak_masuk;
            }
        },
        {
            key: "presensi_summary_presentase_tunkin_telat_masuk",
            text: "",
            className: "presensi_summary_presentase_tunkin_telat_masuk",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Telat Masuk <br />
                    (Tunkin)
                  </div>
                )
              },
            cell : record => {
                return record.presensi_summary_presentase_tunkin_telat_masuk;
            }
        },
        {
            key: "presensi_summary_presentase_ptsp_telat_masuk",
            text: "",
            className: "presensi_summary_presentase_ptsp_telat_masuk",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Telat Masuk <br />
                    (Honorarium)
                  </div>
                )
              },
            cell : record => {
                return record.presensi_summary_presentase_ptsp_telat_masuk;
            }
        },
        {
            key: "presensi_summary_presentase_tunkin_pulang_cepat",
            text: "",
            className: "presensi_summary_presentase_tunkin_pulang_cepat",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Pulang Cepat <br />
                    (Tunkin)
                  </div>
                )
              },
            cell : record => {
                return record.presensi_summary_presentase_tunkin_pulang_cepat;
            }
        },
        {
            key: "presensi_summary_presentase_ptsp_pulang_cepat",
            text: "",
            className: "presensi_summary_presentase_ptsp_pulang_cepat",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Pulang Cepat <br />
                    (Honorarium)
                  </div>
                )
              },
            cell : record => {
                return record.presensi_summary_presentase_ptsp_pulang_cepat;
            }
        },
        {
            key: "presensi_summary_presentase_tunkin_single_finger",
            text: "",
            className: "presensi_summary_presentase_tunkin_single_finger",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Single Finger <br />
                    (Tunkin)
                  </div>
                )
              },
            cell : record => {
                return record.presensi_summary_presentase_tunkin_single_finger;
            }
        },
        {
            key: "presensi_summary_presentase_ptsp_single_finger",
            text: "",
            className: "presensi_summary_presentase_ptsp_single_finger",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Single Finger <br />
                    (Honorarium)
                  </div>
                )
              },
            cell : record => {
                return record.presensi_summary_presentase_ptsp_single_finger;
            }
        },
        {
            key: "presensi_summary_presentase_punishment_discipline",
            text: "",
            className: "presensi_summary_presentase_punishment_discipline",
            align: 'right',
            sortable: true,
            header: () => {
                return (
                  <div className="text-center">
                    Hukuman<br />
                    Disiplin
                  </div>
                )
              },
            cell : record => {
                return record.presensi_summary_presentase_punishment_discipline;
            }
        },
        
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.presensi_summary_id
                const status = record.presensi_summary_status
                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.presensi_summary_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-file-search-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId] : !this.state["detail" + thisId]
                                    })
                                }}
                            >Lihat</Tooltip>
                        </span>
                        {
                            status == 0 &&
                            <span>
                                <button
                                    className="btn btn-success btn-sm"
                                    id={"sync-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            syncUuid: record.presensi_summary_uuid
                                        })
                                        this.handleSync()
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                        <i className="uil-refresh"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["sync" + thisId]} target={"sync-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["sync" + thisId] : !this.state["sync" + thisId]
                                        })
                                    }}
                                >Sinkronisasi</Tooltip>
                            </span>
                        }
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan melakukan sinkronisasi data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/rekap_absensi.html?detail&uuid=" + this.state.detailUuid}/>
                : null }
                {/* { this.state.updateUuid !== null ?
                    <Redirect to={"/kepegawaian/home.html?update&uuid=" + this.state.updateUuid}/>
                : null } */}
            </>
        )
    }

}

export default TableActiveComponent